console.log("💎 ABSOLUTE START: index.jsx execution began");

window.onerror = function(message, source, lineno, colno, error) {
  const errorMsg = document.createElement('div');
  errorMsg.style.cssText = 'position:fixed;top:0;left:0;width:100%;background:red;color:white;padding:20px;z-index:999999;font-family:monospace;white-space:pre-wrap;';
  errorMsg.innerHTML = `<h1>🔥 FATAL ERROR</h1><p>${message}</p><p>at ${source}:${lineno}:${colno}</p><pre>${error?.stack || ''}</pre>`;
  document.body.appendChild(errorMsg);
  console.error("🔥 GLOBAL ERROR:", message, "at", source, ":", lineno, ":", colno, error);
  return false;
};

import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from 'react-redux';
import { BrowserRouter } from "react-router-dom";
import { store } from './store';
import { ThemeProvider } from './components/ThemeProvider';
import PreferencesProvider from './components/PreferencesProvider';
import App from "./App";
import "./styles/tailwind.css";
import "./styles/index.css";

console.log("🚀 REACT ENTRY POINT: index.jsx is executing");
console.log("📦 REDUX STORE INITIALIZED:", !!store);

window.__STATUS_REPORT__ = () => {
  console.log("--- 📋 APP STATUS REPORT ---");
  console.log("Time:", new Date().toISOString());
  console.log("Redux State:", window.__REDUX_STATE__?.auth);
  console.log("Supabase URL:", import.meta.env.VITE_SUPABASE_URL);
  console.log("Document State:", document.readyState);
  console.log("Root element children:", document.getElementById("root")?.children.length);
  console.log("--- 📋 END REPORT ---");
};

window.__FULL_RESET__ = () => {
  console.log("🧹 Performing Full Reset...");
  sessionStorage.clear();
  localStorage.clear();
  window.location.href = "/login";
};

window.__PATCH_AUTH__ = (user = null, loading = false) => {
  console.log("🩹 Patching Auth State...", { user, loading });
  window.__REDUX_STORE__.dispatch({ type: 'auth/setUser', payload: user });
  window.__REDUX_STORE__.dispatch({ type: 'auth/setLoading', payload: loading });
};

window.addEventListener('unhandledrejection', event => {
  const errorMsg = document.createElement('div');
  errorMsg.style.cssText = 'position:fixed;top:0;left:0;width:100%;background:orange;color:white;padding:20px;z-index:999999;font-family:monospace;white-space:pre-wrap;';
  errorMsg.innerHTML = `<h1>🔥 UNHANDLED REJECTION</h1><pre>${event.reason?.stack || event.reason}</pre>`;
  document.body.appendChild(errorMsg);
  console.error('🔥 UNHANDLED REJECTION:', event.reason);
});

// Network Monitor
const originalFetch = window.fetch;
window.fetch = async (...args) => {
  const url = args[0];
  console.log(`🌐 NETWORK FETCH START: ${url}`);
  try {
    const response = await originalFetch(...args);
    console.log(`✅ NETWORK FETCH SUCCESS: ${url} (${response.status})`);
    return response;
  } catch (error) {
    console.error(`❌ NETWORK FETCH ERROR: ${url}`, error);
    throw error;
  }
};

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <ThemeProvider>
      <PreferencesProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </PreferencesProvider>
    </ThemeProvider>
  </Provider>
);